import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { delete_gallery_photo, fetch_gallery_photos, upload_gallery_photo } from './api';
import type { GalleryPhoto, GalleryPhotoType } from './types';

const GALLERY_KEY = ['vendor', 'gallery-photos'] as const;

export function use_gallery_photos() {
  return useQuery({
    queryKey: GALLERY_KEY,
    queryFn: fetch_gallery_photos,
    staleTime: 0,
    retry: 0,
  });
}

export function use_upload_gallery_photo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ type, file }: { type: GalleryPhotoType; file: File }) =>
      upload_gallery_photo(type, file),
    onSuccess: (photos: GalleryPhoto[]) => qc.setQueryData(GALLERY_KEY, photos),
  });
}

export function use_delete_gallery_photo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_gallery_photo(id),
    onSuccess: (_void, id) => {
      qc.setQueryData<GalleryPhoto[]>(GALLERY_KEY, (prev) => prev?.filter((p) => p.id !== id));
      void qc.invalidateQueries({ queryKey: GALLERY_KEY });
    },
  });
}
